import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogTitle } from '@angular/material/dialog';
import { TranslatePipe } from '@ngx-translate/core';
import { MatButton } from '@angular/material/button';

import { RegistrationErrorType } from '../../../../../core/enums';
import { DialogComponent } from '../../../../../core/models/dialog.data';
import { environment } from '../../../../../../environment/environment';

@Component({
  selector: 'dbx-add-box-error-dialog',
  templateUrl: './add-box-error-dialog.component.html',
  styleUrl: './add-box-error-dialog.component.scss',
  imports: [TranslatePipe, MatButton, MatDialogTitle, MatDialogContent, MatDialogActions],
  standalone: true,
})
export class AddBoxErrorDialogComponent extends DialogComponent<
  AddBoxErrorDialogComponent,
  {
    errorType: RegistrationErrorType;
  },
  boolean
> {
  private readonly dialogData = inject<{ errorType: RegistrationErrorType }>(MAT_DIALOG_DATA);

  errorType = this.dialogData.errorType;
  translatePrefix =
    this.errorType === RegistrationErrorType.InvalidInformation
      ? 'addBoxConfirmationDialog.errorDialog.invalidInformation'
      : 'addBoxConfirmationDialog.errorDialog.boxOffline';

  readonly RegistrationErrorType = RegistrationErrorType;

  action(): void {
    this.close(true);
  }

  protected readonly environment = environment;
}
